export default __webpack_public_path__ + "static/media/del_thumb.8768b420.png";